import { writeContract, type SendTransactionResult, prepareWriteContract, fetchFeeData } from '@wagmi/core';
import abi from '../abi';
import { MARKET_ADDRESES, ZERO_ADDRESS } from '../addresses';
import { buildManuallyExecuteDelayedOrder } from '../builders/orders';
import { ethers } from 'ethers';
import { estimateGasLimits } from '../estimateGaslimit';
import { isItBedRockShutDownTime, throwError } from '$lib/home/util';
import { MAX_PRIORITY_FEE_PER_GAS } from '../contants';
import { getMaxFeeAndPriorityFee } from '../utils/gas';

export async function manuallyExecuteDelayedOrder(
	smartContractWalletAddress: `0x${string}`,
	marketIdentifier: string,
	priceUpdateData: Array<string>
): Promise<SendTransactionResult> {
	if (isItBedRockShutDownTime()) {
		throwError();
	}
	const _smartContractWalletAddress = smartContractWalletAddress;
	const targetArray: Array<string> = [];
	const callDataArray: Array<string> = [];
	const functionName: string = 'cast';

	// const marketIdentifier = asset + 'PERP';
	const manuallyExecuteDelayedOrderCallData = await buildManuallyExecuteDelayedOrder(
		MARKET_ADDRESES[marketIdentifier],
		priceUpdateData
	);

	targetArray.push(...manuallyExecuteDelayedOrderCallData._targetArray);
	callDataArray.push(...manuallyExecuteDelayedOrderCallData._callDataArray);

	const gasLimit = await estimateGasLimits(
		_smartContractWalletAddress,
		targetArray,
		callDataArray,
		functionName,
		ethers.BigNumber.from('1')
	);

	const { maxFeePerGas, maxPriorityFeePerGas } = await getMaxFeeAndPriorityFee();


	const config = await prepareWriteContract({
		address: _smartContractWalletAddress as `0x${string}`,
		abi: abi.scWalletMainImpl,
		functionName,
		args: [targetArray, callDataArray, ZERO_ADDRESS],
		gas: gasLimit.toBigInt(),
		value: ethers.BigNumber.from('1').toBigInt() as any,
		maxFeePerGas,
		maxPriorityFeePerGas,
	});

	const txData: SendTransactionResult = await writeContract(config);
	return txData;
}
